import { mapFields } from 'vuex-map-fields';

const vuex_modules =
(form_type) => import(`@/js/forms/store/${form_type}-request-store`);

export default {
	computed: {
		...mapFields(['deadline'])
	},
	methods: {
		async initFormModules(){
			const form_template = await vuex_modules(this.form_type);
			const modules = (await vuex_modules(this.form_type)).default;
			this.deadline = form_template.deadline;
			for(const module in modules){
				if(!this.$store.state.application[module]){
					this.$store.registerModule(['application', module],	 modules[module]);
				}
			}
		},
		async initComponents(){
			const store_directory = (await vuex_modules(this.form_type));
			this.component_array = store_directory.component_array;
		}
	}
}
